import { render, staticRenderFns } from "./BannerSeller.vue?vue&type=template&id=63620dae&scoped=true&name=BannerSeller&"
import script from "./BannerSeller.vue?vue&type=script&lang=js&"
export * from "./BannerSeller.vue?vue&type=script&lang=js&"
import style0 from "./BannerSeller.vue?vue&type=style&index=0&id=63620dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63620dae",
  null
  
)

/* custom blocks */
import block0 from "./BannerSeller.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports